<!-- Document Viewer Mode -->
@if (isDocumentMode) {
	<div class="artifact-panel" [style.width.px]="panelWidth" data-testid="artifact-panel-container">
		<div class="resize-handle" (mousedown)="onResizeStart($event)" data-testid="artifact-panel-panel-resize"></div>
		<div class="panel-header">
			<div class="panel-title-block">
				<h2 class="panel-title">{{ artifactTitle }}</h2>
			</div>
			<div class="panel-header-actions">
				@if (isDocumentDocx) {
					<button class="close-btn" (click)="documentViewer.docxFullscreen = !documentViewer.docxFullscreen" matTooltip="Fullscreen" data-testid="artifact-panel-btn-fullscreen-docx">
						<mat-icon>open_in_full</mat-icon>
					</button>
				}
				@if (isDocumentPdf) {
					<button class="close-btn" (click)="documentViewer.pdfFullscreen = !documentViewer.pdfFullscreen" matTooltip="Fullscreen" data-testid="artifact-panel-btn-fullscreen-pdf">
						<mat-icon>open_in_full</mat-icon>
					</button>
				}
				<button class="close-btn" (click)="onClose()" aria-label="Close panel" data-testid="artifact-panel-btn-close">
					<mat-icon>close</mat-icon>
				</button>
			</div>
		</div>

		<div class="panel-body content-body document-body">
			<app-document-viewer #documentViewer [blob]="documentBlob" [contentType]="documentContentType" [title]="artifactTitle" (download)="onDownloadDocument()"> </app-document-viewer>
		</div>

		<div class="panel-footer">
			<div class="download-buttons">
				<button class="download-btn" (click)="onDownloadDocument()" data-testid="artifact-panel-btn-download">
					<mat-icon>download</mat-icon>
					Download
				</button>
			</div>
		</div>
	</div>
}

<!-- Content/Artifact Mode -->
@if (isContentMode) {
	<div class="artifact-panel" [style.width.px]="panelWidth" data-testid="artifact-panel-container-2">
		<div class="resize-handle" (mousedown)="onResizeStart($event)" data-testid="artifact-panel-panel-resize-2"></div>
		<div class="panel-header">
			<div class="panel-title-block">
				<h2 class="panel-title">{{ artifactTitle }}</h2>
			</div>
			<button class="close-btn" (click)="onClose()" aria-label="Close panel" data-testid="artifact-panel-btn-close-2">
				<mat-icon>close</mat-icon>
			</button>
		</div>

		<app-content-viewer [title]="artifactTitle" [content]="artifactContent"> </app-content-viewer>
	</div>
}
